module.exports = __webpack_public_path__ + "img/2024517-light.df9650a.svg";